export default __webpack_public_path__ + "static/media/header-logout.92d7847e.svg";